<script setup>
import { LeftOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { createConfirmNode } from '@tools'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const props = defineProps({
  title: String,
  backFlag: { type: Boolean, default: false },
  checkBackFun: Function
})

const router = useRouter()
const handleBack = () => {
  const canBack = props.checkBackFun ? props.checkBackFun() : props.backFlag

  if (canBack) {
    // 允许直接返回
    router.back()
  } else {
    // 弹窗确认后返回
    Modal.confirm({
      title: t('message.是否返回上一页？'),
      content: t('message.返回后，页面数据不做保存'),
      icon: createConfirmNode('i_modal_warning'),
      onOk() {
        router.back()
      }
    })
  }
}
</script>

<template>
  <a-layout-header>
    <a-button type="link" @click="handleBack">
      <template #icon>
        <LeftOutlined />
      </template>
      <span class="backText">{{ t('from.返回') }}</span>
    </a-button>
    <a-page-header :title="title" />
  </a-layout-header>
</template>

<style scoped>
.ant-layout-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #edeff2;
}
.ant-btn-link {
  color: #666666;
}
.ant-btn-link:hover {
  color: #1890ff;
}
</style>
